import { ComparisonItem } from "./interface"

export const comparisonItems: ComparisonItem[] = [
  {
    id: 'chargingTime',
    name: '充電時間',
    unit: '時間',
    prefix: '〜',
    image: require('../images/icons/chargingTime.svg')
  },
  {
    id: 'chargingTimeWithDual',
    name: '充電時間（デュアル）',
    unit: '時間',
    prefix: '〜',
    image: require('../images/icons/chargingTime.svg')
  },
  {
    id: 'chargingTimeWithSolar',
    name: '充電時間',
    unit: '時間',
    prefix: '〜',
    isInput: true,
    image: require('../images/icons/chargingTimeWithSolar.svg')
  },
  {
    id: 'chargingTimeWithCar',
    name: '充電時間',
    unit: '時間',
    prefix: '〜',
    isInput: true,
    image: require('../images/icons/chargingTimeWithCar.svg')
  },
  {
    id: 'batteryType',
    name: '電池の種類',
    unit: '',
    prefix: '',
    isInput: true,
    image: require('../images/icons/batteryType.svg')
  },
  {
    id: 'maximumOutput',
    name: 'AC出力 - 通常',
    unit: 'W',
    image: require('../images/icons/maximumOutput.svg')
  },
  {
    id: 'smartphone',
    name: 'スマートフォン',
    power: 10,
    unit: '回',
    image: require('../images/icons/smartphone.svg')
  },
  {
    id: 'electricBlanket',
    name: '電気毛布',
    power: 50,
    unit: '時間',
    image: require('../images/icons/electricBlanket.svg')
  },
  {
    id: 'fan',
    name: '扇風機',
    power: 30,
    unit: '時間',
    image: require('../images/icons/fan.svg')
  },
  {
    id: 'ledLight',
    name: 'LEDライト',
    power: 3,
    unit: '時間',
    image: require('../images/icons/ledLight.svg')
  },
  {
    id: 'riceCooker',
    name: '小型炊飯器',
    power: 250,
    unit: '回',
    image: require('../images/icons/riceCooker.svg')
  },
  {
    id: 'fridge',
    name: '車載冷蔵庫',
    power: 60,
    unit: '時間',
    image: require('../images/icons/fridge.svg')
  },
  {
    id: 'electricCarpet',
    name: '電気カーペット',
    power: 200,
    unit: '時間',
    image: require('../images/icons/electricCarpet.svg')
  },
  {
    id: 'electricPod',
    name: '電気ポッド',
    power: 700,
    unit: '回',
    image: require('../images/icons/electricPod.svg')
  },
  {
    id: 'drill',
    name: '電気ドリル',
    power: 800,
    unit: '分',
    image: require('../images/icons/drill.svg')
  },
  {
    id: 'hairDryer',
    name: 'ヘアドライヤー',
    power: 1000,
    unit: '時間',
    image: require('../images/icons/hairDryer.svg')
  },
  {
    id: 'hotPlate',
    name: 'ホットプレート',
    power: 1300,
    unit: '時間',
    image: require('../images/icons/hotPlate.svg')
  },
  {
    id: 'acPort',
    name: 'AC出力ポート',
    unit: '口',
    image: require('../images/icons/acPort.svg')
  },
  {
    id: 'usbA',
    name: 'USB Type-A',
    unit: '口',
    image: require('../images/icons/usbA.svg')
  },
  {
    id: 'usbC',
    name: 'USB Type-C',
    unit: '口',
    image: require('../images/icons/usbC.svg')
  },
  {
    id: 'qi',
    name: 'ワイヤレス充電',
    unit: '口',
    image: require('../images/icons/qi.svg')
  },
  {
    id: 'builtInLed',
    name: '内臓LEDライト',
    unit: 'ルーメン',
    image: require('../images/icons/builtInLed.svg')
  },
  {
    id: 'weight',
    name: '重量',
    unit: 'kg',
    image: require('../images/icons/weight.svg')
  }
]